import { Button } from "primereact/button";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "@styled-system/css";
import { flex } from "@styled-system/patterns";

export const Submit = styled(Button)`
	${tw`tw-mr-4`}
`;
export const timeInputWrapperClass = flex({
	alignItems: "center",
});
export const timeInputClass = css({
	width: "full",
});
